import {
  SendOTPRequest,
  SendOTPResponse,
} from '@aaa-ncnu-ie/mypolicy-api-registrations';
import { useMutation } from '@tanstack/react-query';

import axios from '../../../axios';

const sendCode = async (requestBody: SendOTPRequest) => {
  const { data } = await axios.post<SendOTPResponse>(
    `${import.meta.env.VITE_REGISTRATIONS_API_URL}/v1/club/otp/send`,
    requestBody
  );

  return data;
};

export const useSendCodeMutation = () =>
  useMutation({
    mutationFn: (requestBody: SendOTPRequest) => sendCode(requestBody),
  });
